// removed by extract-text-webpack-plugin
module.exports = {"wasabi-transfer":"wasabi-transfer","wasabi-transfer-left":"wasabi-transfer-left","wasabi-transfer-right":"wasabi-transfer-right","on":"on","wasabi-transfer-middle":"wasabi-transfer-middle"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Data/Transfer.scss
// module id = 225
// module chunks = 0